<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.changeTime {
  font-size: 20px;
  color: #333;
  font-weight :bold;
}

.span {
  color: #53a0e9;
  font-size: 14px;
  font-weight :normal;
}
.span:hover{
  cursor pointer
}
.map-search{
  background #fff;
  border-top-left-radius 10px;
  border-top-right-radius 10px;
}
.active_btn_r{
    margin-top 20px;
}
</style>

<template>
  <div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1" :provinCode="provinceCode" :moduleName="moduleName" :autoChunkMonth="true"/>
    <div class="home-main">
      <CarPriviceBrand v-if="isCarPriviceShow" @closeHtml="closeHtmls" :dimObj="getNewDimObj()" :dataType="dataType" :tab="num" :proCode="provinceCode" :brandName="brandName"/>
      <div v-else>
        <div class="map-search">
        <el-row>
          <el-col :span="16"><TitleHeader :titleArr="titleArr" :changeTab="changeTab" :tab="tab"/></el-col>
          <el-col :span="3" ><el-button v-show="hideExport" style="margin-top:20px;" @click="exportDate">导出</el-button></el-col>
          <el-col :span="4"><el-button class="active_btn_r"  v-if="jurisdiction(412)" @click="goComp">停靠非石化油站企业列表 >></el-button></el-col>
        </el-row>
        <map-data-table
          :areaList="areaLists"
          v-if="areaLists&&areaLists.length>0"
          :changeCity="changeCity"
          :numIndex="num"
        ></map-data-table>
      </div>
      <div class="map-data">
        <div class="changeTime">
          <el-row>
            <el-col :span="16" :offset="3">
              货运平台车辆停靠{{dataType?dataType:'合计'}}{{brandName}}车次统计 -
              <dimension-popover ref="objDimensionPopover" :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
            </el-col>
            <el-col v-if="countryIs==1 && jurisdiction(413)" :span="16" :offset="3" class="span" @click.native="carPriviceFunc">查看停靠{{dataType}}各地区加油站车次统计 >></el-col>
          </el-row>
        </div>
        <div class="map-area">
          <!-- <home-map :city-data="cardData" :time="mapRangeList" :dataType="dataType" :title="title"></home-map> -->
          <home-map
            :mapRangeList="mapRangeList"
            :dataItem="dataItem"
            :title="title"
          ></home-map>
          <mapBox v-if="showtip"/>
        </div>
        <map-card :cardItem="cardData"  :total="total"></map-card>
      </div>
      </div>
    </div>
    <div v-if="!isCarPriviceShow" class="bottom-top">
      <h4><img src="../../../assets/images/title.png"> <span>说明</span></h4>
      <div>1、S级油站对应省份：货运平台在该省份S级油站停靠次数统计；</div>
      <div>2、C级油站对应省份：货运平台在该省份C级油站停靠次数统计；</div>
      <div>3、E级油站对应省份：货运平台在该省份E级油站停靠次数统计；</div>
      <div>4、所有油站对应省份：货运平台在该省份所有油站停靠次数统计；</div>
      <div>5、注册省：货运平台车辆登记入网的省份。</div>
    </div>
  </div>
</template>
<script>
import SearchBtn from '@/components/searchBtn'
import homeMap from './components/map.vue'
import mapDataTable from './components/mapDataTable.1.vue'
import mapCard from './components/mapCard.vue'
import CardHeader from './components/cardHeader.vue'
import https from '@/api/freight.js'
import http from '@/api/cardData'
import TitleHeader from './components/titleHeader' // title表格
import cityData from './map-data/get-city-value.js'
import geoData from './map-data/get-geography-value.js'
import Cookies from 'js-cookie'
import CarPriviceBrand from '../carPriviceBrand/index.vue'
import exportDate from '@/components/exportDate/index'
import { mapGetters } from 'vuex'
import storage from '@/utils/storage'
import { hideExport } from '@/utils/tools'
import { getGasStationArray,
  getGasStationLabelByBrand,
  getGasStationTypeByBrand } from '@/utils/dictionary'

import Util from '@/utils/util'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'

var now = new Date()
now.setMonth(now.getMonth()-1)
export default {
  name: 'home',
  components: {
    homeMap,
    mapDataTable,
    mapCard,
    SearchBtn,
    CardHeader,
    TitleHeader,
    CarPriviceBrand,
    exportDate,
    dimensionDialog,
    dimensionPopover,
  },
  data() {
    let tab = 0;
    let titleArr = getGasStationArray();
    let brandName = getGasStationLabelByBrand(titleArr[tab]);

    let value4=Util.lastTime(new Date());
    let arr = value4.split('-')
    let dimObj={
      year: arr[0],
      month: arr[1],
      type: "0",
    };
    return {
      firstLoaded:true,
      hideExport:hideExport,
      showtip:false,
      moduleName:"pathwayProvinceOil",
      showExport:false,
      //titleArr: ['所有油站', '中国石油','中国石化','其他油站'],
      titleArr,
      tab,
      num:-1,
      isCarPriviceShow:false,
      cityData: [],
      areaLists: [], //省列表
      dataType: '', //点击省份详情列表
      title: 0, //地图标题
      dataItem: [],
      mapRangeList: [],
      provinceCode: '',
      cardData: [],
      total: 0,
      //brandName:"所有油站",
      brandName,
      countryIs:0,
      progressNum: 0, //进度条进度
      value4,
      dimObj,//纬度对像
    }
  },
  watch: {
    timeSection: function(value, oldValue) {
      this.initData()
    }
  },
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
    ...mapGetters(['sidebar', 'areaList']),
    // titleArr: function() {
    //   return this.$store.state.app.titleArr
    // }
  },
  created() {
    // this.$refs.homeMap.get();
    if(Cookies.get('userType')==2){
      this.num = 0;
      let ls =  this.areaList?this.areaList:storage.get('areaList');
      this.provinceCode = ls[0].provinceCode||''
      this.dataType = ls[0].provinceName||''
      this.countryIs= 1
      this.value4 = ''
      this.carPriviceFunc();
    }else{
      this.initData()
    }

  },
  mounted() {

  },
  methods: {
    getNewDimObj(){
      return cloneDeep(this.dimObj)
    },
     // 地区分品牌停靠次数
    carPriviceFunc(){
      this.isCarPriviceShow=true
    },
    closeHtmls(){
      this.isCarPriviceShow=false
      this.initData()
    },
    changeTab(index,item) {
      let that = this
      that.tab = index
      that.brandName=item
      that.getData()
    },
    changeDimension(e){
      if(e.isOk){
        this.value4 = e.values;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      this.getData()
    },
    initData() {
      let that = this
       https
        .getProvinces({})
        .then(e => {
          that.areaLists = e.data
          if(Cookies.get('userType')!=1  && Cookies.get('userType')!=2){
            that.areaLists = [
              {
                'provinceName': '全国'
              }
            ].concat(e.data||[])
          }
          that.changeCity(0)
        })
    },
    goComp() {
      this.$router.push({
        name: 'carUnpetrifiedCom',
      })
    },
     // 取消导出
    hideExport1() {
      this.showExport = false
    },
    //导出
    exportDate() {
      this.showExport = true
    },
    getData() {
      let that = this
      https
        .getBrandList({
          yearMonth: that.value4? that.value4.split('-').join(''):'',
          proCode: that.provinceCode?that.provinceCode:'',
          //type:that.tab,
          type:getGasStationTypeByBrand(that.brandName),
          countryIs:that.countryIs,
          timeType:get(this,"dimObj.type","0")
        })
        .then(e => {
          let data = e.data[0]
          if(this.firstLoaded){
            this.firstLoaded=false;
            if(data&&data.time){
              that.value4=data.time;
              let arr = that.value4.split('-')
              set(this,"dimObj.year",arr[0])
              set(this,"dimObj.month",arr[1])
              this.$refs.objDimensionPopover.setCtrlValue();
            }
          }
          that.total = data.sum
          if(data.sum==0){
            that.dataItem = []
            that.mapRangeList=[{end:0,start:0,label:"无"}]
            this.showtip=true
            return
          }else{
            this.showtip=false
            let tempArr= ['第1-3名', '第4-7名', '第8-12名', '第13-18名', '第19-31名'] //地图图例汉字
            if (e.data[0].mapRangeList.length) {
              for (let i = 0; i < e.data[0].mapRangeList.length; i++) {
                // if (e.data.mapRangeList[i].end == -1) {
                  e.data[0].mapRangeList[i].label = tempArr[i]
                //     e.data.mapRangeList[i].start + ' 以上'
                //   delete e.data.mapRangeList[i].end
                // }
              }
              that.mapRangeList = [...e.data[0].mapRangeList]
              that.dataItem = that.handleSeriesData({
                data: e.data[0].list,
              })
            }
            that.cardData = [...data.list]
            }
        })
    },
      handleSeriesData({ index = 0, data }) {
      let that = this
      let arrs = JSON.stringify(data)
      let handleArr = JSON.parse(arrs)
      handleArr.forEach(e => {
        e.name = e.registProvince
        if (index == 0) {
          e.value =e.countNum
        } else if (index == 1) {
          e.value = e.time_0_6
        } else if (index == 2) {
          e.value = e.time_6_12
        } else if (index == 3) {
          e.value = e.time_12_18
        } else if (index == 4) {
          e.value = e.time_18_24
        } else {
         e.value =e.countNum
        }
      })
      return handleArr
    },
    changeCity(index) {
      let that = this
      that.num = index
      let areaLists = this.areaLists
      that.provinceCode = areaLists[index].provinceCode
      that.dataType = areaLists[index].provinceName
      if(that.provinceCode){
        that.countryIs=1
      }else{
        that.countryIs=0
      }
      this.getData()
    },
    childData() {
      var convertData = function(data) {
        let res = []
        let len = data.length
        for (var i = 0; i < len; i++) {
          var geoCoord = geoData[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
        return res
      }
    }
  }
}
</script>
